import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';

import { INodeStatus } from '../top-bar-dto';
import { Subscription } from 'rxjs';
import { TooltipPosition } from '@angular/material/tooltip';
import { TopBarService } from '../top-bar.service';
import { isEmpty } from '@ubi-cell/core-utils';
import { StorageService } from 'libs/base/src/lib/services/storage.service';

@Component({
    selector: 'ubi-cell-subpanel-dropdown',
    templateUrl: './subpanel-dropdown.component.html',
    styleUrls: ['./subpanel-dropdown.component.scss'],
    standalone: false
})
export class SubpanelDropdownComponent implements OnInit, OnChanges {
  @Input() control: any;
  @Input() mainScreen: string = '';
  @Input() subScreen: string = '';
  @Input() targetSubpanel: string = '';
  subpanelList: any = [];
  selectedValue: any;
  selectedSubpanel: any;
  nodeStatusSub$: Subscription;
  selectedProduct: Subscription;
  constructor(public _topBarConf: TopBarService, public _storageService: StorageService,  private cdRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.nodeStatusSub$ = this._topBarConf?.currTopBarConfig?.subscribe(
      (status) => {
        if (!isEmpty(status)) {
          if(status.label === "node_migration_summary"){
            this.selectedValue = this._storageService.getStorageItem('targetSubpanel');
          }
          this.subpanelList = status['node_status']?.subpanel_list || [];
        }
      }
    );
    this.selectedProduct = this._storageService.selectedValue$.subscribe(
      (value) => {        
        if(value){          
          let selectedSubpanel = this.subpanelList[0]?.controls[0]?.dataset.filter((data) => data.key == value.key);
          if(selectedSubpanel){
            this.selectedSubpanel = selectedSubpanel[0];
          }
        }else{
          this.selectedSubpanel = value;
        }
        this.cdRef.detectChanges(); 
      }
    );
  }

  ngOnChanges(): void {
    let data = this.subpanelList[0]?.controls[0];
    if (data?.type === 'dropdown' && data?.dataset?.length === 1) {      
      this.selectedValue = data?.dataset[0];
      this.selectedSubpanel = data?.dataset[0];
      this.selectionChange({ key: this.selectedValue.key, value: this.selectedValue.label });
    }
  }


  selectionChange(data) {
    this._topBarConf.currentSubpanelConfig.next(data);
  }

  ngOnDestroy(): void {
    if (this.nodeStatusSub$) {
      this.nodeStatusSub$.unsubscribe();
    }
    this._topBarConf.currentSubpanelConfig.next({});
    this._storageService.setSelectedValue(null);
  }
}